import { RemoteRecurringPushNotificationList } from 'data/usecases/push-notification/remote-recurring-push-notification-list';
import { RecurringPushNotificationListUseCaseInterface } from 'domain/usecases/push-notification/recurring-push-notification-list';
import { makeApiUrlRecurringPushNotification } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRecurringPushNotificationList =
  (): RecurringPushNotificationListUseCaseInterface =>
    new RemoteRecurringPushNotificationList(
      makeApiUrlRecurringPushNotification(),
      makeAxiosHttpClient(),
    );
